module.exports = __webpack_public_path__ + "media/images/site/step-one-2ea641a6829f86f5ce8c33f86fbd6cc5.svg";